var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04838 12.263C9.04838 11.927 9.07405 11.612 9.12538 11.318C9.18138 11.024 9.28405 10.744 9.43338 10.478C9.55938 10.226 9.70638 10.023 9.87438 9.869C10.047 9.71033 10.2337 9.55633 10.4344 9.407C10.6397 9.253 10.8544 9.057 11.0784 8.819C11.265 8.61367 11.3887 8.406 11.4494 8.196C11.5147 7.986 11.5474 7.75967 11.5474 7.517C11.5474 7.33967 11.5264 7.174 11.4844 7.02C11.4424 6.866 11.3724 6.733 11.2744 6.621C11.125 6.43433 10.936 6.30367 10.7074 6.229C10.4787 6.14967 10.2407 6.11 9.99338 6.11C9.76938 6.11 9.55472 6.14033 9.34938 6.201C9.14872 6.26167 8.98072 6.355 8.84538 6.481C8.70072 6.60233 8.59338 6.754 8.52338 6.936C8.45805 7.11333 8.42772 7.307 8.43238 7.517H6.89238C6.92972 7.07833 7.04172 6.66767 7.22838 6.285C7.41505 5.90233 7.66705 5.592 7.98438 5.354C8.25505 5.13933 8.56305 4.98067 8.90838 4.878C9.25372 4.77067 9.59905 4.717 9.94438 4.717C10.439 4.717 10.9057 4.794 11.3444 4.948C11.7877 5.102 12.1564 5.35167 12.4504 5.697C12.665 5.93967 12.826 6.21733 12.9334 6.53C13.0454 6.838 13.1014 7.15767 13.1014 7.489C13.1014 7.93233 13.0057 8.343 12.8144 8.721C12.6277 9.099 12.3874 9.44433 12.0934 9.757C11.9394 9.92033 11.783 10.0697 11.6244 10.205C11.4657 10.3357 11.3187 10.464 11.1834 10.59C11.048 10.716 10.936 10.8537 10.8474 11.003C10.7214 11.2177 10.649 11.4113 10.6304 11.584C10.6117 11.752 10.6024 11.9783 10.6024 12.263H9.04838ZM9.05538 15V13.306H10.6024V15H9.05538Z",
    fill: "#4A4F5C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 9,
    stroke: "#ABABAB",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/question-mark-icon.07a060911ae2d4655e11df01bf223fee.svg";
export { ForwardRef as ReactComponent };